import {
  CountryListResponse,
  UpdateInterestedCountryPayload,
  UpdateInterestedCountryRes,
} from "@/store/types/countryTypes";
import axiosInstance from "@/utils/axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "../loader/loaderSlice";
import { InstituteResponse } from "@/store/types/aiCourseFinder";
import { buildQueryString } from "@/utils/buildQueryString";

export const getCountryList = createAsyncThunk<CountryListResponse>(
  "country/getCountryList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(`/country`, {});
      const data = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data?.list)
        ? res.data.list
        : [];
      return { list: data, total: data.length };
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

interface GetCountryUniversityListArgs {
  countryId: string | string[] | number;
  fields?: string;
  courseLevel?: string;
  offset?: number;
  limit?: number;
  sort?: { [key: string]: string | number | boolean };
  collegeName?: string;
}

export const getCountryUniversityList = createAsyncThunk<
  InstituteResponse,
  GetCountryUniversityListArgs
>(
  "country/getCountryUniversityList",
  async (
    { countryId, fields, courseLevel, offset, limit, sort, collegeName },
    { rejectWithValue, dispatch }
  ) => {
    const queryParams = `?fields=${fields ?? ""}`;
    const courseParams = courseLevel ? `&courseLevel=${courseLevel}` : "";
    const searchParams = `&search=limit=${limit ?? 10},offset=${offset ?? 0}`;
    const sortParams = `&sort=${buildQueryString(sort ?? {})}`;
    const collegeParam = collegeName ? `&collegeName=${encodeURIComponent(collegeName)}` : "";

    dispatch(startLoading());
    try {
      const { data } = await axiosInstance(
        `/country/universities/${countryId}${queryParams}${courseParams}${searchParams}${sortParams}${collegeParam}`
      );
      dispatch(stopLoading());
      return {
        list: data.data,
        total: data.total,
        status: true,
        all_course_level: data?.all_course_level,
        total_pages: data?.total_pages,
        all_course_specialisation: data?.all_course_specialisation,
        all_course_duration: data?.all_course_duration,
        all_course_stream: data?.total_pages,
        college_specialisation_category: data?.college_specialisation_category,
      };
    } catch (e) {
      dispatch(stopLoading());
      return rejectWithValue(e);
    }
  }
);

export const updateInterestedCountries = createAsyncThunk<
  UpdateInterestedCountryRes,
  UpdateInterestedCountryPayload
>(
  "user/updateInterestedCountries",
  async ({ id, payload }, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    try {
      if (!id) {
        dispatch(stopLoading());
        return rejectWithValue("No id provided");
      }
      const res = await axiosInstance.patch(
        `students/update/interested/countries/${id}`,
        payload
      );

      dispatch(stopLoading());
      return { status: true, message: res.data.message };
    } catch (e) {
      dispatch(stopLoading());
      return rejectWithValue(e);
    }
  }
);
